import { defineComponent as _defineComponent } from 'vue'
import { Picture, Typo } from '@travelata-libs/ui-kit';
  import { pluralize } from '@travelata-libs/utils';
  import { computed } from 'vue';
  import { isTravelataOperatorId } from '@entities/operator';
  import { PARTNERS_WORD_FORMS, SQUARE_LOGO_OPERATOR_IDS } from '../config';
  import { getProviderLogo } from '../lib/getProviderLogo';
  import useRoomProviders from '../lib/useRoomProviders';
  import { type ProviderOffer } from '../model/types';

  interface RoomProvidersSummaryProps {
    offers: ProviderOffer[];
  }
  
export default /*#__PURE__*/_defineComponent({
  __name: 'RoomProvidersSummary',
  props: {
    offers: null
  },
  setup(__props: any) {

const props = __props as {
    offers: ProviderOffer[];
  }

  
  const { providers } = useRoomProviders(() => props.offers);

  const MAX_SUMMARY_LOGOS = 2;
  const summaryLogos = computed(() =>
    [...providers.value].sort((providerA, providerB) => providerA.price - providerB.price).slice(0, MAX_SUMMARY_LOGOS),
  );

  const isTravelataOnly = computed(
    () => providers.value.length > 0 && providers.value.every((provider) => isTravelataOperatorId(provider.operatorId)),
  );

  const priceSourceLabel = computed(() =>
    isTravelataOnly.value ? 'Travelata' : pluralize(PARTNERS_WORD_FORMS, providers.value.length),
  );

return { __sfc: true,props, providers, MAX_SUMMARY_LOGOS, summaryLogos, isTravelataOnly, priceSourceLabel, Picture, Typo, SQUARE_LOGO_OPERATOR_IDS, getProviderLogo }
}

})